import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useGetSalariesQuery } from 'actions/salaries/queries';
import { useDeleteSalariesMutation, useUpdateSalariesMutation } from 'actions/salaries/mutations';

const useClientData = (dossierId) => {
  const {
    data: clientResponse,
    isLoading: isLoadingClients,
    refetch,
  } = useGetSalariesQuery({ dossier_id: dossierId });

  const [updateClient] = useUpdateSalariesMutation()
  const [deleteClient] = useDeleteSalariesMutation()

  const [updatedClients, setUpdatedClients] = useState([]);

  useEffect(() => {
    if (
      !isLoadingClients &&
      clientResponse?.data &&
      Array.isArray(clientResponse.data)
    ) {
      const enhancedClients = clientResponse.data.map((client) => ({
        ...client,
        displayName: `${client.nom} (${client.id})`,
      }));
      setUpdatedClients(enhancedClients);
    }
    refetch()
  }, [isLoadingClients, clientResponse]);

  const handleUpdateClient = async (clientId, updateData) => {
    try {
      await updateClient({
        id: clientId,
        ...updateData,
      }).unwrap();
      refetch(); // Refetch client data from the backend
    } catch (error) {
      toast.error(`Update error: ${error.data?.error || error.message}`);
      console.error('Request failed:', error);
    }
  };

  const handleDeleteClient = async (clientId) => {
    try {
      await deleteClient({ id: clientId }).unwrap();
      toast.success('Client deleted successfully');
      refetch();
    } catch (error) {
      console.log(clientId)
      toast.error(`Deletion error: ${error.data?.error || error.message}`);
    }
  };

  return { updatedClients, handleUpdateClient, handleDeleteClient, refetch };
};

export default useClientData;
